// extracted by mini-css-extract-plugin
export default {"brand":"Navbar_brand__gyPuy"};